import { useState } from 'react';
import { useSiteConfig, useSiteConfigDispatch } from '../../../context/SiteConfigContext';
import { useT } from '../../../hooks/useT';
import styles from '../PropertyPanel.module.css';

function I18nTextField({ label, translationKey, multiline = false, onKeyChange }) {
  const config = useSiteConfig();
  const dispatch = useSiteConfigDispatch();
  const t = useT();
  const lang = config.meta.lang;
  const [newValue, setNewValue] = useState('');
  const value = translationKey ? t(translationKey) : '';

  const handleChange = (newVal) => {
    dispatch({
      type: 'UPDATE_I18N',
      lang,
      key: translationKey,
      value: newVal,
    });
  };

  // Auto-generate a unique translation key based on label
  const handleCreate = () => {
    if (!newValue.trim()) return;
    const slug = label.toLowerCase().replace(/[^a-z0-9]+/g, '_');
    const autoKey = `custom.${slug}_${Date.now().toString(36)}`;
    dispatch({
      type: 'UPDATE_I18N',
      lang,
      key: autoKey,
      value: newValue.trim(),
    });
    if (onKeyChange) {
      onKeyChange(autoKey);
    }
    setNewValue('');
  };

  const handleKeyDown = (e) => {
    if (e.key === 'Enter' && !multiline) {
      e.preventDefault();
      handleCreate();
    }
  };

  if (!translationKey) {
    return (
      <div className={styles.field}>
        <span className={styles.fieldLabel}>{label}</span>
        {multiline ? (
          <textarea
            className={styles.textarea}
            placeholder={`Enter ${label.toLowerCase()}...`}
            value={newValue}
            onChange={(e) => setNewValue(e.target.value)}
            rows={3}
          />
        ) : (
          <input
            type="text"
            className={styles.input}
            placeholder={`Enter ${label.toLowerCase()}...`}
            value={newValue}
            onChange={(e) => setNewValue(e.target.value)}
            onKeyDown={handleKeyDown}
          />
        )}
        {newValue.trim() && (
          <button
            onClick={handleCreate}
            style={{
              padding: '0.4rem 0.75rem',
              background: 'var(--text-accent)',
              color: 'var(--bg-primary)',
              border: 'none',
              borderRadius: '4px',
              cursor: 'pointer',
              fontSize: '0.75rem',
              fontWeight: '500',
              marginTop: '0.25rem',
            }}
          >
            Save
          </button>
        )}
      </div>
    );
  }

  if (multiline) {
    return (
      <label className={styles.field}>
        <span className={styles.fieldLabel}>{label}</span>
        <textarea
          className={styles.textarea}
          value={value || ''}
          onChange={(e) => handleChange(e.target.value)}
          rows={3}
        />
      </label>
    );
  }

  return (
    <label className={styles.field}>
      <span className={styles.fieldLabel}>{label}</span>
      <input
        type="text"
        className={styles.input}
        value={value || ''}
        onChange={(e) => handleChange(e.target.value)}
      />
    </label>
  );
}

export default I18nTextField;
